document.addEventListener('DOMContentLoaded', () => {
  const stepLabels = ["Choose Your PANDATIME Edition","Choose Your Table Mat","Choose Your Rack & Pusher","Choose Your Bag","Review Your Complete Set"];
  const matCodes = {
    'navy-fern-american-mah-jongg-mat': 'NVF', 'peacock-tide-american-mah-jongg-mat': 'PCT', 'blossom-lattice-american-mah-jongg-mat': 'BLT',
    'midnight-garden-american-mah-jongg-mat': 'MDG', 'folk-bloom-american-mah-jongg-mat': 'FKB', 'crane-medallion-american-mah-jongg-mat': 'CRM',
    'powder-blue-rose-american-mah-jongg-mat': 'PBR', 'porcelain-garden-american-mah-jongg-mat': 'PRG', 'sea-glass-lotus-american-mah-jongg-mat': 'SGL',
    'hydrangea-check-american-mah-jongg-mat': 'HCK', 'berry-meadow-american-mah-jongg-mat': 'BRM', 'gilded-mountain-american-mah-jongg-mat': 'GDM',
    'coastal-seahorse-american-mah-jongg-mat': 'CSH'
  };
  const matPreviewScales = { 'navy-fern-american-mah-jongg-mat': 1.18 };

  document.querySelectorAll('[data-complete-set-builder]').forEach((builder) => {
    let catalog = null;
    try {
      catalog = JSON.parse(builder.querySelector('[data-builder-catalog]')?.textContent || 'null');
    } catch (error) {
      console.error('AFTER FOUR bundle catalog could not be read.', error);
    }
    const catalogGroups = {
      bag: catalog?.bags || [],
      mat: catalog?.mats || [],
      tile: catalog?.tiles || [],
      rack: catalog?.racks || []
    };
    const state = {
      step: 1,
      bagSeries: 'signature',
      bag: { id: 'after-four-logo-barbie-pink-bag-set', label: 'Barbie Pink Logo Bag Set', image: builder.querySelector('[data-builder-select="bag"][aria-pressed="true"]')?.dataset.builderImage || '', meta: '$95 USD', price: 95 },
      bagVariant: null,
      mat: null, matSize: null, matVariant: null,
      tile: null, tileVariant: null,
      rackProduct: null, rack: null, rackVariant: null,
      adding: false,
      addingAction: ''
    };
    const one = (selector) => builder.querySelector(selector);
    const all = (selector) => Array.from(builder.querySelectorAll(selector));
    const money = (value) => `$${value}`;
    const regularValue = () => 469 + 90 + 55 + state.bag.price;

    function requestedQuantity() {
      const input = one('[data-builder-quantity]');
      return Math.max(1, Number.parseInt(input?.value || '1', 10) || 1);
    }

    function updateQuantity(direction) {
      const input = one('[data-builder-quantity]');
      if (!input) return;
      const current = requestedQuantity();
      input.value = String(Math.max(1, current + direction));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function catalogProduct(group, handle) {
      return (catalogGroups[group] || []).find((product) => product.handle === handle) || null;
    }

    function catalogVariant(group, handle, sku = '') {
      const product = catalogProduct(group, handle);
      if (!product) return null;
      const variants = Array.isArray(product.variants) ? product.variants : [];
      return (sku ? variants.find((variant) => variant.sku === sku) : variants.find((variant) => variant.available)) || null;
    }

    function variantGid(variant) {
      const id = String(variant?.id || '');
      return /^\d+$/.test(id) ? `gid://shopify/ProductVariant/${id}` : '';
    }

    function selectedVariants() {
      return [state.bagVariant, state.matVariant, state.tileVariant, state.rackVariant];
    }

    function hasCompleteCatalogMapping() {
      return selectedVariants().every((variant) => variant?.available && variantGid(variant));
    }

    function selectedParentVariant() {
      const variants = catalog?.parent?.tileVariants;
      if (!state.tile?.id || !Array.isArray(variants)) return null;
      const matches = variants.filter((variant) => variant.tileHandle === state.tile.id);
      return matches.length === 1 ? matches[0] : null;
    }

    function parentIsConfigured() {
      const variant = selectedParentVariant();
      return variant?.available === true && /^\d+$/.test(String(variant.id || '')) && Number(variant.price) === 56900;
    }

    function setText(selector, value) { all(selector).forEach((node) => { node.textContent = value; }); }

    function selectCard(kind, button) {
      all(`[data-builder-select="${kind}"]`).forEach((item) => {
        const selected = item === button;
        item.setAttribute('aria-pressed', String(selected));
        item.closest('.complete-set-option')?.classList.toggle('is-selected', selected);
        const status = item.querySelector('.complete-set-option__body i');
        if (status) status.textContent = selected ? 'SELECTED' : 'SELECT';
      });
    }

    function preview(item, eyebrow, metaLabel, mode = '') {
      const image = one('[data-builder-preview-image]');
      const media = image?.closest('.complete-set-preview__media');
      if (image && item?.image) { image.src = item.image; image.alt = item.label; }
      if (media) {
        const isTableMat = mode === 'table-mat';
        media.classList.toggle('is-table-mat-preview', isTableMat);
        if (isTableMat) media.style.setProperty('--bundle-preview-scale', String(matPreviewScales[item?.id] || 1.4));
        else media.style.removeProperty('--bundle-preview-scale');
      }
      setText('[data-builder-preview-label]', eyebrow);
      setText('[data-builder-preview-name]', item?.label || 'Complete your selection');
      setText('[data-builder-preview-meta-label]', metaLabel || 'SELECTION DETAILS');
      setText('[data-builder-preview-meta]', item?.meta || 'Not selected');
      if (media?.hasAttribute('data-desktop-builder-gallery')) {
        const product = Object.values(catalogGroups).flat().find((entry) => entry.handle === item?.id);
        const productImages = (product?.images || []).filter(Boolean);
        const useProductGallery = productImages.length > 0 && (catalogGroups.bag.includes(product) || catalogGroups.mat.includes(product));
        // Bags and mats use a theme-asset preview of the same first product photo.
        // Do not prepend that separate URL to their existing product gallery.
        const gallery = { label: item?.label || 'Product image', images: useProductGallery ? productImages : [item?.image, ...productImages].filter(Boolean) };
        media.dataset.desktopGallery = JSON.stringify(gallery);
        media.dispatchEvent(new CustomEvent('builder:preview-gallery', { detail: gallery }));
      }
    }

    function itemFromButton(button) {
      if (!button) return null;
      return {
        id: button.dataset.builderValue,
        label: button.dataset.builderLabel,
        image: button.dataset.builderImage,
        meta: button.dataset.builderMeta || (button.dataset.builderSelect === 'rack-variant' ? '$55 USD' : ''),
        price: Number(button.dataset.builderPrice) || 0
      };
    }

    const sheet = one('[data-builder-sheet]');
    const sheetBackdrop = one('[data-builder-sheet-backdrop]');
    const sheetContent = one('[data-builder-sheet-content]');
    const sheetScroll = one('[data-builder-sheet-scroll]');
    const sheetTitle = one('[data-builder-sheet-title]');
    const sheetStep = one('[data-builder-sheet-step]');
    const sheetFooter = one('[data-builder-sheet-footer]');
    const sheetConfirm = one('[data-builder-sheet-confirm]');
    const sheetPrevious = one('[data-builder-sheet-previous]');
    const sheetAdd = one('[data-builder-sheet-add]');
    const sheetCheckout = one('[data-builder-sheet-checkout]');
    const sheetPriceLabel = one('[data-builder-sheet-price-label]');
    const sheetPrice = one('[data-builder-sheet-price]');
    const mobileBuilderQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let sheetDraft = null;
    const sheetStepDrafts = new Map();
    let sheetOpener = null;
    let sheetCloseTimer = 0;
    let sheetSwipe = null;
    let sheetZoomOpener = null;
    let sheetZoomImages = [];
    let sheetZoomIndex = 0;
    let sheetZoomPointer = null;
    let sheetZoomRenderToken = 0;
    const sheetZoomImageCache = new Map();
    let lockedScrollY = 0;

    function escapeMarkup(value) {
      return String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
    }

    function optimizedZoomImage(source) {
      if (!source) return '';
      try {
        const url = new URL(source, window.location.href);
        const isShopifyImage = url.hostname.includes('cdn.shopify.com') || url.pathname.includes('/cdn/shop/');
        if (isShopifyImage) url.searchParams.set('width', mobileBuilderQuery.matches ? '1200' : '2000');
        return url.href;
      } catch (error) {
        return source;
      }
    }

    function preloadSheetZoomImage(index) {
      if (!sheetZoomImages.length) return Promise.resolve(null);
      const normalizedIndex = (index + sheetZoomImages.length) % sheetZoomImages.length;
      const source = optimizedZoomImage(sheetZoomImages[normalizedIndex]?.src);
      if (!source) return Promise.resolve(null);
      if (sheetZoomImageCache.has(source)) return sheetZoomImageCache.get(source);

      const preload = new Promise((resolve) => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = async () => {
          try {
            if (typeof image.decode === 'function') await image.decode();
          } catch (error) {
            // A completed load is still safe to display when decode() is unsupported or interrupted.
          }
          resolve(source);
        };
        image.onerror = () => {
          sheetZoomImageCache.delete(source);
          resolve(null);
        };
        image.src = source;
      });
      sheetZoomImageCache.set(source, preload);
      return preload;
    }

    function preloadAdjacentSheetZoomImages() {
      if (sheetZoomImages.length < 2) return;
      preloadSheetZoomImage(sheetZoomIndex + 1);
      preloadSheetZoomImage(sheetZoomIndex - 1);
    }

    function closeSheetZoom({ restoreFocus = true } = {}) {
      const zoom = sheet?.querySelector('[data-sheet-preview-zoom-dialog]');
      if (!zoom || zoom.hidden) return false;
      zoom.hidden = true;
      zoom.classList.remove('is-open');
      if (restoreFocus) sheetZoomOpener?.focus({ preventScroll: true });
      sheetZoomOpener = null;
      sheetZoomImages = [];
      sheetZoomIndex = 0;
      sheetZoomPointer = null;
      sheetZoomRenderToken += 1;
      return true;
    }

    async function renderSheetZoomImage() {
      const zoom = sheet?.querySelector('[data-sheet-preview-zoom-dialog]');
      if (!zoom || !sheetZoomImages.length) return;
      const current = sheetZoomImages[sheetZoomIndex];
      const zoomImage = zoom.querySelector('img');
      const stage = zoom.querySelector('[data-sheet-preview-zoom-stage]');
      const counter = zoom.querySelector('[data-sheet-preview-zoom-counter]');
      const previous = zoom.querySelector('[data-sheet-preview-zoom-previous]');
      const next = zoom.querySelector('[data-sheet-preview-zoom-next]');
      const hasMultiple = sheetZoomImages.length > 1;
      const requestedIndex = sheetZoomIndex;
      const renderToken = ++sheetZoomRenderToken;
      stage?.classList.add('is-loading');
      stage?.setAttribute('aria-busy', 'true');
      const source = await preloadSheetZoomImage(requestedIndex);
      if (renderToken !== sheetZoomRenderToken || requestedIndex !== sheetZoomIndex || !source) {
        if (renderToken === sheetZoomRenderToken) {
          stage?.classList.remove('is-loading');
          stage?.removeAttribute('aria-busy');
        }
        return;
      }
      zoomImage.classList.add('is-changing');
      zoomImage.src = source;
      zoomImage.alt = hasMultiple ? `${current.alt} — image ${requestedIndex + 1} of ${sheetZoomImages.length}` : current.alt;
      if (counter) counter.textContent = `${String(requestedIndex + 1).padStart(2, '0')} / ${String(sheetZoomImages.length).padStart(2, '0')}`;
      if (previous) previous.hidden = !hasMultiple;
      if (next) next.hidden = !hasMultiple;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => zoomImage.classList.remove('is-changing'));
      });
      stage?.classList.remove('is-loading');
      stage?.removeAttribute('aria-busy');
      preloadAdjacentSheetZoomImages();
    }

    function moveSheetZoom(direction) {
      if (sheetZoomImages.length < 2) return;
      sheetZoomIndex = (sheetZoomIndex + direction + sheetZoomImages.length) % sheetZoomImages.length;
      renderSheetZoomImage();
    }

    function openSheetZoom(opener) {
      if (!sheet || !opener) return;
      const sourceImage = opener.querySelector('img');
      if (!sourceImage?.src) return;
      let zoom = sheet.querySelector('[data-sheet-preview-zoom-dialog]');
      if (!zoom) {
        zoom = document.createElement('div');
        zoom.className = 'complete-set-sheet-zoom';
        zoom.dataset.sheetPreviewZoomDialog = '';
        zoom.hidden = true;
        zoom.setAttribute('role', 'dialog');
        zoom.setAttribute('aria-modal', 'true');
        zoom.setAttribute('aria-label', 'Larger product image');
        zoom.innerHTML = '<button type="button" data-sheet-preview-zoom-close aria-label="Close larger image">&times;</button><div class="complete-set-sheet-zoom__stage" data-sheet-preview-zoom-stage><button type="button" data-sheet-preview-zoom-previous aria-label="Previous product image">&larr;</button><img alt=""><button type="button" data-sheet-preview-zoom-next aria-label="Next product image">&rarr;</button></div><div class="complete-set-sheet-zoom__meta"><span data-sheet-preview-zoom-counter>01 / 01</span><p>SWIPE OR USE ARROWS TO VIEW ALL PRODUCT IMAGES</p></div>';
        sheet.append(zoom);
        const zoomStage = zoom.querySelector('[data-sheet-preview-zoom-stage]');
        zoomStage?.addEventListener('pointerdown', (event) => {
          if (event.target.closest('button')) return;
          sheetZoomPointer = { pointerId: event.pointerId, startX: event.clientX, startY: event.clientY };
        });
        const finishZoomSwipe = (event) => {
          if (!sheetZoomPointer || event.pointerId !== sheetZoomPointer.pointerId) return;
          const deltaX = event.clientX - sheetZoomPointer.startX;
          const deltaY = event.clientY - sheetZoomPointer.startY;
          sheetZoomPointer = null;
          if (Math.abs(deltaX) >= 44 && Math.abs(deltaX) > Math.abs(deltaY)) moveSheetZoom(deltaX > 0 ? -1 : 1);
        };
        zoomStage?.addEventListener('pointerup', finishZoomSwipe);
        zoomStage?.addEventListener('pointercancel', () => { sheetZoomPointer = null; });
      }
      const galleryGroup = opener.dataset.sheetGalleryGroup || '';
      const galleryHandle = opener.dataset.sheetGalleryHandle || '';
      const productImages = galleryGroup && galleryHandle ? catalogProduct(galleryGroup, galleryHandle)?.images : null;
      const sources = Array.isArray(productImages) && productImages.length ? productImages : [sourceImage.currentSrc || sourceImage.src];
      sheetZoomImages = Array.from(new Set(sources.filter(Boolean))).map((src) => ({ src, alt: sourceImage.alt || 'Product image' }));
      sheetZoomIndex = 0;
      renderSheetZoomImage();
      zoom.setAttribute('aria-label', sourceImage.alt ? `Larger image of ${sourceImage.alt}` : 'Larger product image');
      sheetZoomOpener = opener.closest('button') || opener;
      zoom.hidden = false;
      requestAnimationFrame(() => {
        zoom.classList.add('is-open');
        zoom.querySelector('[data-sheet-preview-zoom-close]')?.focus();
      });
    }

    function optionEyebrow(button) {
      return button?.querySelector('.complete-set-option__body small')?.textContent?.trim() || 'AFTER FOUR COMPLETE SET';
    }

    function buttonBy(kind, value, product = '') {
      return all(`[data-builder-select="${kind}"]`).find((button) => button.dataset.builderValue === value && (!product || button.dataset.builderProduct === product)) || null;
    }

    function bagSeriesFor(id) {
      const button = buttonBy('bag', id);
      return button?.closest('[data-builder-bag-panel]')?.dataset.builderBagPanel || state.bagSeries || 'signature';
    }

    function mobileChoiceData(step) {
      if (step === 4 && state.bag) return {
        image: state.bag.image,
        label: optionEyebrow(buttonBy('bag', state.bag.id)),
        name: state.bag.label,
        option: bagSeriesFor(state.bag.id) === 'signature' ? 'Signature three-piece set' : 'Logo-free essential style',
        price: state.bag.meta
      };
      if (step === 2 && state.mat && state.matSize) return {
        image: state.mat.image,
        label: 'AMERICAN MAH JONGG TABLE MAT',
        name: state.mat.label,
        option: `${state.matSize} × ${state.matSize} cm`,
        price: '$90 USD'
      };
      if (step === 1 && state.tile) return {
        image: state.tile.image,
        label: 'FIXED PANDATIME EDITION',
        name: state.tile.label,
        option: 'Fixed face-and-back pairing',
        price: '$469 RETAIL VALUE'
      };
      if (step === 3 && state.rackProduct && state.rack) return {
        image: state.rack.image || state.rackProduct.image,
        label: 'STANDARD RACK + PUSHER SET',
        name: state.rack.label,
        option: state.rack.id,
        price: '$55 USD'
      };
      return null;
    }

    function mobileChooseLabel(step) {
      return ['CHOOSE AN EDITION', 'CHOOSE A MAT', 'CHOOSE A STYLE', 'CHOOSE A BAG'][step - 1];
    }

    function updateMobileChoiceCards() {
      all('[data-builder-mobile-choice]').forEach((choice) => {
        const step = Number(choice.dataset.builderMobileChoice);
        const selection = mobileChoiceData(step);
        if (!selection) {
          choice.innerHTML = `<div class="complete-set-mobile-choice__empty"><span>No selection yet</span></div><button type="button" data-builder-sheet-open="${step}">${mobileChooseLabel(step)}</button>`;
          return;
        }
        choice.innerHTML = `<div class="complete-set-mobile-choice__media"><img src="${escapeMarkup(selection.image)}" alt="${escapeMarkup(selection.name)}" loading="lazy" decoding="async"></div><div class="complete-set-mobile-choice__body"><p class="af-eyebrow">${escapeMarkup(selection.label)}</p><h4>${escapeMarkup(selection.name)}</h4><p>${escapeMarkup(selection.option)}</p><strong>${escapeMarkup(selection.price)}</strong></div><button type="button" data-builder-sheet-open="${step}">CHANGE SELECTION</button>`;
      });
    }

    function draftSelectedButton(step) {
      if (!sheetDraft) return null;
      if (step === 4) return buttonBy('bag', sheetDraft.bagId) || all('[data-builder-select="bag"]').find((button) => !button.disabled && button.closest('[data-builder-bag-panel]')?.dataset.builderBagPanel === sheetDraft.bagSeries) || null;
      if (step === 2) return buttonBy('mat', sheetDraft.matId) || all('[data-builder-select="mat"]').find((button) => !button.disabled) || null;
      if (step === 1) return buttonBy('tile', sheetDraft.tileId) || all('[data-builder-select="tile"]').find((button) => !button.disabled) || null;
      if (step === 3) return buttonBy('rack-variant', sheetDraft.rackSku, sheetDraft.rackProductId) || buttonBy('rack-product', sheetDraft.rackProductId) || all('[data-builder-select="rack-product"]').find((button) => !button.disabled) || null;
      return null;
    }

    function sheetIsValid() {
      if (!sheetDraft) return false;
      if (sheetDraft.step === 4) return Boolean(sheetDraft.bagId);
      if (sheetDraft.step === 2) return Boolean(sheetDraft.matId && sheetDraft.matSize);
      if (sheetDraft.step === 1) return Boolean(sheetDraft.tileId);
      if (sheetDraft.step === 3) return Boolean(sheetDraft.rackProductId && sheetDraft.rackSku);
      if (sheetDraft.step === 5) return !missingSelections().length && parentIsConfigured() && hasCompleteCatalogMapping();
      return false;
    }

    function sheetDraftFromState(step) {
      return {
        step,
        bagSeries: state.bagSeries || bagSeriesFor(state.bag?.id),
        bagId: state.bag?.id || '',
        matId: state.mat?.id || '',
        matSize: state.matSize || '',
        tileId: state.tile?.id || '',
        rackProductId: state.rackProduct?.id || '',
        rackSku: state.rack?.id || ''
      };
    }

    function resetSheetScroll() {
      if (!sheetScroll) return;
      sheetScroll.scrollTop = 0;
      sheetScroll.classList.remove('is-preview-compact');
    }

    function showSheetStep(step) {
      if (step < 1 || step > 5) return;
      const fieldsByStep = { 1: ['tileId'], 2: ['matId', 'matSize'], 3: ['rackProductId', 'rackSku'], 4: ['bagSeries', 'bagId'] };
      if (sheetDraft && fieldsByStep[sheetDraft.step]) {
        sheetStepDrafts.set(sheetDraft.step, Object.fromEntries(fieldsByStep[sheetDraft.step].map((key) => [key, sheetDraft[key]])));
      }
      sheetDraft = { ...sheetDraftFromState(step), ...sheetStepDrafts.get(step), step };
      renderSheet();
      resetSheetScroll();
      requestAnimationFrame(() => sheetTitle?.focus({ preventScroll: true }));
    }

    function sheetCard(button, action, checked) {
      const item = itemFromButton(button);
      if (!item) return '';
      const galleryGroup = ['bag', 'mat', 'tile'].includes(action) ? action : '';
      const galleryData = galleryGroup ? ` data-sheet-gallery-group="${galleryGroup}" data-sheet-gallery-handle="${escapeMarkup(item.id)}"` : '';
      const zoomLabel = galleryGroup ? 'VIEW IMAGES' : 'VIEW IMAGE';
      const zoomTitle = galleryGroup ? `View all product images for ${item.label}` : `View a larger image of ${item.label}`;
      return `<button class="complete-set-sheet-option${button.disabled ? ' is-unavailable' : ''}" type="button" role="radio" aria-checked="${checked}" data-sheet-select="${action}" data-sheet-value="${escapeMarkup(item.id)}"${button.dataset.builderProduct ? ` data-sheet-product="${escapeMarkup(button.dataset.builderProduct)}"` : ''}${button.disabled ? ' disabled' : ''}><span class="complete-set-sheet-option__media" data-sheet-preview-zoom${galleryData} title="${escapeMarkup(zoomTitle)}"><img src="${escapeMarkup(item.image)}" alt="${escapeMarkup(item.label)}" loading="lazy" decoding="async"><b aria-hidden="true">${zoomLabel}</b></span><span><small>${escapeMarkup(optionEyebrow(button))}</small><strong>${escapeMarkup(item.label)}</strong><em>${escapeMarkup(item.meta)}</em></span><i aria-hidden="true">${checked ? '✓' : ''}</i></button>`;
    }

    function compactSheetButton({ action, value, title, meta, checked, product = '', disabled = false }) {
      return `<button type="button" role="radio" aria-checked="${checked}" data-sheet-select="${action}" data-sheet-value="${escapeMarkup(value)}"${product ? ` data-sheet-product="${escapeMarkup(product)}"` : ''}${disabled ? ' disabled' : ''}><strong>${escapeMarkup(title)}</strong>${meta ? `<small>${escapeMarkup(meta)}</small>` : ''}<i aria-hidden="true">${checked ? '✓' : ''}</i></button>`;
    }

    function sheetReviewItem({ step, number, type, item, detail }) {
      const media = item?.image
        ? `<img src="${escapeMarkup(item.image)}" alt="${escapeMarkup(item.label || type)}" loading="lazy" decoding="async">`
        : '<b aria-hidden="true">+</b>';
      return `<button class="complete-set-sheet-review__item${item ? '' : ' is-missing'}" type="button" data-sheet-edit-step="${step}" aria-label="Change ${escapeMarkup(type)}"><span class="complete-set-sheet-review__media">${media}</span><span class="complete-set-sheet-review__copy"><small>${number} · ${escapeMarkup(type)}</small><strong>${escapeMarkup(item?.label || 'Selection required')}</strong><em>${escapeMarkup(detail || 'Selection required')}</em></span><i>CHANGE</i></button>`;
    }

    function updateSheetPurchaseControls() {
      if (!sheetDraft || sheetDraft.step !== 5) return;
      if (sheetPrevious) sheetPrevious.disabled = state.adding;
      const ready = sheetIsValid();
      if (sheetAdd) {
        sheetAdd.disabled = !ready || state.adding;
        sheetAdd.textContent = state.adding && state.addingAction === 'bag' ? 'ADDING TO BAG…' : 'ADD COMPLETE SET TO BAG';
      }
      if (sheetCheckout) {
        sheetCheckout.disabled = !ready || state.adding;
        sheetCheckout.textContent = state.adding && state.addingAction === 'checkout' ? 'OPENING CHECKOUT…' : 'BUY COMPLETE SET NOW — $398';
      }
    }

    function renderSheet() {
      if (!sheetDraft || !sheetContent || !sheetTitle || !sheetStep || !sheetConfirm || !sheetPrice) return;
      const titles = ["Choose Your PANDATIME Edition","Choose Your Table Mat","Choose Your Rack & Pusher","Choose Your Carrying Bag","Review & Checkout"];
      const nextLabels = ['NEXT: CHOOSE TABLE MAT →', 'NEXT: CHOOSE RACK & PUSHER →', 'NEXT: CHOOSE BAG →', 'REVIEW YOUR COMPLETE SET →'];
      sheetStep.textContent = `STEP ${sheetDraft.step} OF 5`;
      sheetTitle.textContent = titles[sheetDraft.step - 1];
      const previewButton = draftSelectedButton(sheetDraft.step);
      const previewItem = itemFromButton(previewButton);
      let controls = '';

      if (sheetDraft.step === 4) {
        const bagButtons = all('[data-builder-select="bag"]').filter((button) => button.closest('[data-builder-bag-panel]')?.dataset.builderBagPanel === sheetDraft.bagSeries);
        controls = `<div class="complete-set-sheet__section"><p class="af-eyebrow">CHOOSE A BAG SERIES</p><div class="complete-set-sheet__tabs" role="radiogroup" aria-label="Carrying bag series"><button type="button" role="radio" aria-checked="${sheetDraft.bagSeries === 'signature'}" data-sheet-series="signature">SIGNATURE BAGS</button><button type="button" role="radio" aria-checked="${sheetDraft.bagSeries === 'essential'}" data-sheet-series="essential">ESSENTIAL BAGS</button></div></div><div class="complete-set-sheet__section"><p class="af-eyebrow">CHOOSE A BAG</p><div class="complete-set-sheet__options" role="radiogroup" aria-label="Available carrying bags">${bagButtons.map((button) => sheetCard(button, 'bag', sheetDraft.bagId === button.dataset.builderValue)).join('')}</div></div>`;
      }
      if (sheetDraft.step === 2) {
        const matButtons = all('[data-builder-select="mat"]');
        const sizeButtons = all('[data-builder-select="mat-size"]');
        const sizeReminder = sheetDraft.matId && !sheetDraft.matSize ? '<p class="complete-set-sheet__size-reminder" role="status"><strong>SIZE REQUIRED</strong><span>Choose a table mat size before continuing.</span></p>' : '';
        controls = `<div class="complete-set-sheet__section"><p class="af-eyebrow">CHOOSE A MAT DESIGN</p><div class="complete-set-sheet__options" role="radiogroup" aria-label="Available table mat designs">${matButtons.map((button) => sheetCard(button, 'mat', sheetDraft.matId === button.dataset.builderValue)).join('')}</div></div><div class="complete-set-sheet__section complete-set-sheet__size-section" data-sheet-size-section><p class="af-eyebrow">CHOOSE A SIZE</p>${sizeReminder}<div class="complete-set-sheet__compact-options" role="radiogroup" aria-label="Table mat sizes">${sizeButtons.map((button) => { const sku = sheetDraft.matId ? `AF-MAT-${matCodes[sheetDraft.matId]}-${button.dataset.builderValue}` : ''; const available = sku ? catalogVariant('mat', sheetDraft.matId, sku)?.available : false; return compactSheetButton({ action: 'mat-size', value: button.dataset.builderValue, title: `${button.dataset.builderValue} × ${button.dataset.builderValue} cm`, meta: sku, checked: sheetDraft.matSize === button.dataset.builderValue, disabled: !available }); }).join('')}</div></div>`;
      }
      if (sheetDraft.step === 1) {
        const tileButtons = all('[data-builder-select="tile"]');
        controls = `<div class="complete-set-sheet__section"><p class="af-eyebrow">CHOOSE AN EDITION</p><p class="complete-set-sheet__note">Each edition has one confirmed face-and-back pairing.</p><div class="complete-set-sheet__options" role="radiogroup" aria-label="PANDATIME editions">${tileButtons.map((button) => sheetCard(button, 'tile', sheetDraft.tileId === button.dataset.builderValue)).join('')}</div></div>`;
      }
      if (sheetDraft.step === 3) {
        const rackButtons = all('[data-builder-select="rack-product"]');
        const variantButtons = sheetDraft.rackProductId ? all('[data-builder-select="rack-variant"]').filter((button) => button.dataset.builderProduct === sheetDraft.rackProductId) : [];
        controls = `<div class="complete-set-sheet__section"><p class="af-eyebrow">CHOOSE A STYLE</p><div class="complete-set-sheet__options" role="radiogroup" aria-label="Standard rack and pusher styles">${rackButtons.map((button) => sheetCard(button, 'rack-product', sheetDraft.rackProductId === button.dataset.builderValue)).join('')}</div></div>${variantButtons.length ? `<div class="complete-set-sheet__section"><p class="af-eyebrow">CHOOSE A COLOR</p><div class="complete-set-sheet__compact-options" role="radiogroup" aria-label="Rack and pusher colors">${variantButtons.map((button) => compactSheetButton({ action: 'rack-variant', value: button.dataset.builderValue, title: button.querySelector('span')?.textContent?.trim() || button.dataset.builderValue, meta: button.querySelector('small')?.textContent?.trim() || '', checked: sheetDraft.rackSku === button.dataset.builderValue, product: button.dataset.builderProduct, disabled: button.disabled })).join('')}</div></div>` : ''}`;
      }
      if (sheetDraft.step === 5) {
        const matDetail = state.matSize ? `${state.matSize} × ${state.matSize} cm` : 'Size required';
        controls = `<section class="complete-set-sheet-review"><p class="af-eyebrow">YOUR PANDATIME COMPLETE SET</p><div class="complete-set-sheet-review__items">${[
          sheetReviewItem({ step: 1, number: '01', type: 'PANDATIME Edition', item: state.tile, detail: state.tile?.meta }),
          sheetReviewItem({ step: 2, number: '02', type: 'Table Mat', item: state.mat, detail: matDetail }),
          sheetReviewItem({ step: 3, number: '03', type: 'Rack & Pusher', item: state.rack || state.rackProduct, detail: state.rack?.meta || 'Color required' }),
          sheetReviewItem({ step: 4, number: '04', type: 'Carrying Bag', item: state.bag, detail: state.bag?.meta })
        ].join('')}</div><div class="complete-set-sheet-review__included"><section><span>05 · INCLUDED</span><strong>Five Premium Table Essentials</strong><em>Included with your complete set</em><ul aria-label="Included premium table essentials"><li><b>Premium Dragon Dice ×2</b><small>Assorted colors</small></li><li><b>Premium Wind Direction Die ×1</b><small>Assorted color</small></li><li><b>100 Scoring Chips</b><small>Mixed colors</small></li><li><b>Layered Mah Jongg Tile Tray</b><small>For organized storage</small></li><li><b>Accessory Storage Pouch</b><small>For smaller essentials</small></li></ul></section><p><span>ALSO INCLUDED</span><strong>2026 Mah Jongg Card</strong><em>Included with your complete set</em></p></div><div class="complete-set-sheet-review__value"><p><span>MAIN COMPONENTS SEPARATELY</span><del>${escapeMarkup(money(regularValue()))}</del></p><p><span>COMPLETE SET PRICE</span><strong>$569 USD</strong></p><p><span>COMPONENT SAVINGS</span><em>${escapeMarkup(money(regularValue() - 569))}</em></p></div><p class="complete-set-sheet-review__assurance">Review every selected piece before adding your complete set to your bag or continuing directly to secure checkout.</p></section>`;
      }

      const isTableMatPreview = sheetDraft.step === 2;
      const selectedPreviewCanZoom = sheetDraft.step === 3;
      const needsMatSize = isTableMatPreview && Boolean(sheetDraft.matId) && !sheetDraft.matSize;
      const previewMedia = selectedPreviewCanZoom
        ? `<button class="complete-set-sheet__preview-media is-zoomable" type="button" data-sheet-preview-zoom aria-label="View a larger image of ${escapeMarkup(previewItem?.label || 'selected rack and pusher set')}"><img src="${escapeMarkup(previewItem?.image || '')}" alt="${escapeMarkup(previewItem?.label || '')}" decoding="async"><span>VIEW LARGER</span></button>`
        : `<div class="complete-set-sheet__preview-media"><img src="${escapeMarkup(previewItem?.image || '')}" alt="${escapeMarkup(previewItem?.label || '')}" decoding="async"></div>`;
      const previewDetail = needsMatSize
        ? '<p class="complete-set-sheet__preview-reminder"><strong>SIZE REQUIRED</strong><span>Choose a size below to continue.</span></p>'
        : `<p>${isTableMatPreview && sheetDraft.matSize ? `${escapeMarkup(sheetDraft.matSize)} × ${escapeMarkup(sheetDraft.matSize)} cm` : escapeMarkup(previewItem?.meta || '')}</p>`;
      const previewMarkup = previewItem ? `<article class="complete-set-sheet__preview${isTableMatPreview ? ' is-table-mat-preview' : ''}">${previewMedia}<section><p class="af-eyebrow">${escapeMarkup(optionEyebrow(previewButton))}</p><h4>${escapeMarkup(previewItem.label)}</h4>${previewDetail}</section></article>` : '';
      const compactPreviewMedia = selectedPreviewCanZoom
        ? `<button class="complete-set-sheet__compact-preview-media is-zoomable" type="button" data-sheet-preview-zoom aria-label="View a larger image of ${escapeMarkup(previewItem?.label || 'selected rack and pusher set')}"><img src="${escapeMarkup(previewItem?.image || '')}" alt="${escapeMarkup(previewItem?.label || '')}" decoding="async"><span>VIEW LARGER</span></button>`
        : `<div class="complete-set-sheet__compact-preview-media"><img src="${escapeMarkup(previewItem?.image || '')}" alt="${escapeMarkup(previewItem?.label || '')}" decoding="async"></div>`;
      const compactPreviewMarkup = previewItem ? `<article class="complete-set-sheet__compact-preview${isTableMatPreview ? ' is-table-mat-preview' : ''}">${compactPreviewMedia}<section><p class="af-eyebrow">${escapeMarkup(optionEyebrow(previewButton))}</p><h4>${escapeMarkup(previewItem.label)}</h4>${previewDetail}</section></article>` : '';
      sheetContent.innerHTML = `${compactPreviewMarkup}${previewMarkup}${controls}`;
      if (sheetDraft.step === 5) {
        const offerPreview = one('.af-first-order-preview');
        const reviewValue = sheetContent.querySelector('.complete-set-sheet-review__value');
        if (offerPreview && reviewValue) reviewValue.replaceWith(offerPreview.cloneNode(true));
      }
      const isReview = sheetDraft.step === 5;
      sheetFooter?.classList.toggle('is-review', isReview);
      if (sheetPriceLabel) sheetPriceLabel.textContent = 'COMPLETE SET';
      sheetPrice.innerHTML = '<s>$569 USD</s> $398 USD';
      sheetConfirm.hidden = isReview;
      if (sheetPrevious) {
        sheetPrevious.hidden = sheetDraft.step === 1;
        sheetPrevious.disabled = state.adding;
      }
      sheetConfirm.textContent = needsMatSize ? 'SELECT A SIZE TO CONTINUE ↓' : (nextLabels[sheetDraft.step - 1] || 'NEXT STEP →');
      sheetConfirm.disabled = !sheetIsValid() && !needsMatSize;
      if (sheetAdd) sheetAdd.hidden = !isReview;
      if (sheetCheckout) sheetCheckout.hidden = !isReview;
      updateSheetPurchaseControls();
    }

    function updateSheetPreviewMode() {
      if (!sheetScroll) return;
      const active = sheetScroll.classList.contains('is-preview-compact');
      const shouldCompact = active ? sheetScroll.scrollTop > 8 : sheetScroll.scrollTop > 48;
      if (active !== shouldCompact) sheetScroll.classList.toggle('is-preview-compact', shouldCompact);
    }

    function lockBuilderScroll() {
      lockedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.width = '100%';
      document.body.classList.add('af-builder-sheet-open');
    }

    function unlockBuilderScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.classList.remove('af-builder-sheet-open');
      // Restore the background immediately, even when the theme enables smooth scrolling.
      window.scrollTo({ top: lockedScrollY, left: 0, behavior: 'instant' });
    }

    function closeSheet({ restoreFocus = true, immediate = false } = {}) {
      if (!sheet || sheet.hidden) return;
      closeSheetZoom({ restoreFocus: false });
      clearTimeout(sheetCloseTimer);
      sheet.classList.remove('is-open');
      sheetBackdrop?.classList.remove('is-open');
      const finish = () => {
        sheet.hidden = true;
        if (sheetBackdrop) sheetBackdrop.hidden = true;
        sheet.style.removeProperty('transform');
        unlockBuilderScroll();
        // Returning keyboard focus must not scroll the background to the opener.
        if (restoreFocus) sheetOpener?.focus({ preventScroll: true });
        sheetDraft = null;
        sheetOpener = null;
      };
      if (immediate || reducedMotionQuery.matches) finish();
      else sheetCloseTimer = window.setTimeout(finish, 260);
    }

    function openSheet(step, opener) {
      if (!sheet || !sheetBackdrop || !mobileBuilderQuery.matches || step < 1 || step > 5) return;
      clearTimeout(sheetCloseTimer);
      sheetOpener = opener;
      sheetStepDrafts.clear();
      sheetDraft = sheetDraftFromState(step);
      renderSheet();
      sheet.hidden = false;
      sheetBackdrop.hidden = false;
      lockBuilderScroll();
      resetSheetScroll();
      requestAnimationFrame(() => {
        sheet.classList.add('is-open');
        sheetBackdrop.classList.add('is-open');
        sheetTitle?.focus({ preventScroll: true });
      });
    }

    function commitSheetDraft() {
      if (!sheetDraft || !sheetIsValid()) return;
      const step = sheetDraft.step;
      if (step === 4) {
        one(`[data-builder-bag-series="${sheetDraft.bagSeries}"]`)?.click();
        buttonBy('bag', sheetDraft.bagId)?.click();
      }
      if (step === 2) {
        buttonBy('mat', sheetDraft.matId)?.click();
        buttonBy('mat-size', sheetDraft.matSize)?.click();
      }
      if (step === 1) buttonBy('tile', sheetDraft.tileId)?.click();
      if (step === 3) {
        buttonBy('rack-product', sheetDraft.rackProductId)?.click();
        buttonBy('rack-variant', sheetDraft.rackSku, sheetDraft.rackProductId)?.click();
      }
      if (step < 5) showSheetStep(step + 1);
    }

    function missingSelections() {
      const missing = [];
      if (!state.bag || !state.bagVariant?.available) missing.push('available carrying bag');
      if (!state.mat) missing.push('table mat');
      if (state.mat && !state.matSize) missing.push('mat size');
      if (state.mat && state.matSize && !state.matVariant?.available) missing.push('available mat size');
      if (!state.tile) missing.push('tile edition');
      if (state.tile && !state.tileVariant?.available) missing.push('available tile edition');
      if (!state.rackProduct) missing.push('rack style'); else if (!state.rack) missing.push('rack color');
      if (state.rack && !state.rackVariant?.available) missing.push('available rack color');
      return missing;
    }

    function naturalList(items) {
      if (items.length < 2) return items[0] || '';
      if (items.length === 2) return `${items[0]} and ${items[1]}`;
      return `${items.slice(0, -1).join(', ')}, and ${items.at(-1)}`;
    }

    function updateValues() {
      const regular = regularValue();
      const saved = regular - 569;
      setText('[data-builder-regular-value]', money(regular));
      setText('[data-builder-savings]', money(saved));
      setText('[data-builder-summary-regular]', money(regular));
      setText('[data-builder-summary-savings]', money(saved));
      setText('[data-builder-mobile-savings]', 'WELCOME OFFER $398 · AT CHECKOUT');
    }

    function updateReview() {
      const target = one('[data-builder-review-items]');
      if (!target) return;
      const matMeta = state.mat ? (state.matSize ? `${state.matSize} × ${state.matSize} cm · AF-MAT-${matCodes[state.mat.id]}-${state.matSize}` : 'SIZE REQUIRED') : 'SELECTION REQUIRED';
      const items = [
        ['01', 'PANDATIME Edition', state.tile?.label, state.tile?.image, state.tile?.meta],
        ['02', 'Table Mat', state.mat?.label, state.mat?.image, matMeta],
        ['03', 'Rack & Pusher', state.rack?.label || state.rackProduct?.label, state.rack?.image || state.rackProduct?.image, state.rack?.meta || 'COLOR REQUIRED'],
        ['04', 'Carrying Bag', state.bag?.label, state.bag?.image, state.bag?.meta]
      ];
      target.replaceChildren(...items.map(([number, type, label, image, meta]) => {
        const article = document.createElement('article');
        article.className = `complete-set-review-item${label ? '' : ' is-missing'}`;
        article.innerHTML = `${image ? `<img src="${image}" alt="">` : '<span class="complete-set-review-item__placeholder">+</span>'}<div><small>${number} · ${type}</small><strong>${label || 'Choose this item'}</strong><span>${meta || 'SELECTION REQUIRED'}</span></div>`;
        return article;
      }));
    }

    function updateSummary() {
      setText('[data-builder-summary="bag"]', state.bag.label);
      setText('[data-builder-summary="mat"]', state.mat ? `${state.mat.label}${state.matSize ? ` · ${state.matSize} × ${state.matSize} cm` : ' · Select size'}` : 'Not selected');
      setText('[data-builder-summary="tile"]', state.tile?.label || 'Not selected');
      setText('[data-builder-summary="rack"]', state.rack?.label || state.rackProduct?.label || 'Not selected');
      const missing = missingSelections();
      const add = one('[data-builder-add]');
      const buyNow = one('[data-builder-buy-now]');
      const message = one('[data-builder-missing]');
      const ready = !missing.length && parentIsConfigured() && hasCompleteCatalogMapping();
      if (add) {
        add.disabled = !ready || state.adding;
        add.textContent = state.adding && state.addingAction === 'bag'
          ? 'ADDING TO BAG…'
          : (missing.length ? 'COMPLETE YOUR SELECTIONS' : (ready ? 'ADD COMPLETE SET TO BAG' : 'COMPLETE SET UNAVAILABLE'));
      }
      if (buyNow) {
        buyNow.disabled = !ready || state.adding;
        buyNow.textContent = state.adding && state.addingAction === 'checkout'
          ? 'OPENING CHECKOUT…'
          : 'BUY COMPLETE SET NOW';
      }
      if (message) {
        if (missing.length) message.textContent = `Still needed: ${naturalList(missing)}.`;
        else if (!parentIsConfigured()) message.textContent = 'The complete set is not yet available to add to your bag.';
        else if (!hasCompleteCatalogMapping()) message.textContent = 'One or more selections are currently unavailable.';
        else message.textContent = 'All selections are complete and ready to add to your bag.';
      }
      updateReview();
      updateValues();
      updateMobileChoiceCards();
      updateSheetPurchaseControls();
    }

    function refreshMatVariant() {
      state.matVariant = state.mat && state.matSize
        ? catalogVariant('mat', state.mat.id, `AF-MAT-${matCodes[state.mat.id]}-${state.matSize}`)
        : null;
      all('[data-builder-select="mat-size"]').forEach((button) => {
        const variant = state.mat ? catalogVariant('mat', state.mat.id, `AF-MAT-${matCodes[state.mat.id]}-${button.dataset.builderValue}`) : null;
        button.disabled = Boolean(state.mat) && !variant?.available;
        button.classList.toggle('is-unavailable', Boolean(state.mat) && !variant?.available);
      });
    }

    function decorateCatalogAvailability() {
      all('[data-builder-select="bag"]').forEach((button) => {
        const variant = catalogVariant('bag', button.dataset.builderValue);
        button.disabled = !variant?.available;
        button.closest('.complete-set-option')?.classList.toggle('is-unavailable', !variant?.available);
      });
      all('[data-builder-select="mat"]').forEach((button) => {
        const product = catalogProduct('mat', button.dataset.builderValue);
        const available = product?.variants?.some((variant) => variant.available);
        button.disabled = !available;
        button.closest('.complete-set-option')?.classList.toggle('is-unavailable', !available);
      });
      all('[data-builder-select="tile"]').forEach((button) => {
        const variant = catalogVariant('tile', button.dataset.builderValue);
        button.disabled = !variant?.available;
        button.closest('.complete-set-option')?.classList.toggle('is-unavailable', !variant?.available);
      });
      all('[data-builder-select="rack-product"]').forEach((button) => {
        const product = catalogProduct('rack', button.dataset.builderValue);
        const available = product?.variants?.some((variant) => variant.available);
        button.disabled = !available;
        button.closest('.complete-set-option')?.classList.toggle('is-unavailable', !available);
      });
      all('[data-builder-select="rack-variant"]').forEach((button) => {
        const variant = catalogVariant('rack', button.dataset.builderProduct, button.dataset.builderValue);
        button.disabled = !variant?.available;
        button.classList.toggle('is-unavailable', !variant?.available);
      });
      refreshMatVariant();
    }

    function configuredLineItem() {
      if (!parentIsConfigured()) throw new Error('The selected tile edition is not available as a complete set. Please choose it again.');
      return {
        id: Number(selectedParentVariant().id),
        quantity: requestedQuantity(),
        properties: {
          _af_bundle: catalog.marker || 'pandatime-v1',
          _af_bag_variant: variantGid(state.bagVariant),
          _af_mat_variant: variantGid(state.matVariant),
          _af_tile_variant: variantGid(state.tileVariant),
          _af_rack_variant: variantGid(state.rackVariant),
          Bag: state.bag.label,
          'Table Mat': `${state.mat.label} · ${state.matSize} × ${state.matSize} cm`,
          'Tile Edition': state.tile.label,
          'Rack & Pusher': state.rack.label,
          'Premium Table Essentials': 'Dragon Dice ×2 · Wind Direction Die ×1 · 100 Scoring Chips ×1 · Tile Tray ×1 · Accessory Storage Pouch ×1',
          'Also Included': '2026 Mah Jongg Card'
        }
      };
    }

    function replaceCartDrawer(markup) {
      if (!markup) return null;
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const nextSection = parsed.querySelector('#shopify-section-cart-drawer-section');
      const currentSection = document.querySelector('#shopify-section-cart-drawer-section');
      if (!nextSection || !currentSection) return null;
      currentSection.replaceWith(nextSection);
      return nextSection.querySelector('theme-drawer#cart-drawer');
    }

    function updateHeaderCartCount(itemCount) {
      document.querySelectorAll('.af-site-header__actions [aria-controls="cart-drawer"]').forEach((control) => {
        control.textContent = `BAG (${itemCount})`;
      });
    }

    async function addCompleteSet(destination = 'bag', feedbackButton = null) {
      if (state.adding || missingSelections().length || !parentIsConfigured() || !hasCompleteCatalogMapping()) return;
      state.adding = true;
      state.addingAction = destination;
      updateSummary();
      const message = one('[data-builder-missing]');
      const status = one('[data-builder-purchase-status]');
      if (status) status.textContent = '';
      try {
        const body = { items: [configuredLineItem()] };
        if (destination === 'bag') {
          body.sections = ['cart-drawer-section'];
          body.sections_url = window.location.pathname;
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result?.description || result?.message || 'The complete set could not be added.');

        if (destination === 'checkout') {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
          return;
        }

        const drawer = replaceCartDrawer(result.sections?.['cart-drawer-section']);
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null).catch(() => null);
        if (cart) updateHeaderCartCount(cart.item_count);

        state.adding = false;
        state.addingAction = '';
        if (status) status.textContent = 'Your customized complete set has been added to your bag.';
        updateSummary();
        window.afterFourAddFeedback?.({ button: feedbackButton, image: result.items?.[0]?.featured_image?.url || state.tile?.image, count: cart?.item_count });
      } catch (error) {
        state.adding = false;
        state.addingAction = '';
        const errorMessage = error instanceof Error ? error.message : 'The complete set could not be added. Please try again.';
        if (message) message.textContent = errorMessage;
        if (status) status.textContent = errorMessage;
        updateSummary();
      }
    }

    function showStep(nextStep, shouldScroll) {
      state.step = Math.min(5, Math.max(1, Number(nextStep) || 1));
      builder.dataset.activeStep = String(state.step);
      all('[data-builder-step]').forEach((panel) => {
        const active = Number(panel.dataset.builderStep) === state.step;
        panel.hidden = !active; panel.classList.toggle('is-active', active);
      });
      all('[data-builder-step-go]').forEach((button) => button.setAttribute('aria-current', Number(button.dataset.builderStepGo) === state.step ? 'step' : 'false'));
      const previous = one('[data-builder-previous]');
      if (previous) previous.disabled = state.step === 1;
      const next = one('[data-builder-next]');
      if (next) { next.disabled = state.step === 5; next.textContent = state.step === 4 ? 'REVIEW COMPLETE SET →' : 'NEXT →'; }
      setText('[data-builder-step-count]', `STEP ${state.step} OF 5`);
      setText('[data-builder-mobile-step-count]', `STEP ${state.step} OF 5`);
      setText('[data-builder-mobile-step-title]', stepLabels[state.step - 1]);
      all('.complete-set-mobile-step__progress i').forEach((item, index) => item.classList.toggle('is-active', index < state.step));
      if (state.step === 5) updateReview();
      syncPreviewForCurrentStep();
      if (shouldScroll) one('.complete-set-mobile-step')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      requestAnimationFrame(updateAllRails);
    }

    function updateRail(rail) {
      const controls = rail?.nextElementSibling;
      if (!rail || !controls?.classList.contains('complete-set-rail-controls')) return;
      const previous = controls.querySelector('[data-builder-rail-previous]');
      const next = controls.querySelector('[data-builder-rail-next]');
      const bar = controls.querySelector('.complete-set-rail-progress span');
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const progress = max ? rail.scrollLeft / max : 0;
      if (previous) previous.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
      if (bar) {
        const width = Math.max(18, Math.min(1, rail.clientWidth / Math.max(rail.scrollWidth, 1)) * 100);
        bar.style.width = `${width}%`;
        bar.style.transform = `translateX(${progress * ((100 - width) / Math.max(width, 1)) * 100}%)`;
      }
    }
    function updateAllRails() { all('[data-builder-rail]').forEach(updateRail); }

    function syncPreviewForCurrentStep() {
      if (state.step === 4) {
        preview(state.bag || itemFromButton(one('[data-builder-select="bag"]')), 'AFTER FOUR SIGNATURE BAGS', 'INDEPENDENT RETAIL');
        return;
      }
      if (state.step === 2) {
        const item = state.mat || itemFromButton(one('[data-builder-select="mat"]'));
        preview(item, 'AMERICAN MAH JONGG TABLE MAT', state.matSize ? 'SELECTED SIZE' : 'SIZE REQUIRED', 'table-mat');
        if (state.mat && state.matSize) setText('[data-builder-preview-meta]', `${state.matSize} × ${state.matSize} cm · AF-MAT-${matCodes[state.mat.id]}-${state.matSize}`);
        return;
      }
      if (state.step === 1) {
        preview(state.tile || itemFromButton(one('[data-builder-select="tile"]')), 'PANDATIME FIXED EDITION', 'INDEPENDENT RETAIL VALUE');
        return;
      }
      if (state.step === 3) {
        preview(state.rack || state.rackProduct || itemFromButton(one('[data-builder-select="rack-product"]')), 'STANDARD RACK + PUSHER SET', state.rack ? 'SELECTED COLOR' : 'CHOOSE A COLOR');
      }
    }

    all('[data-builder-select="bag"]').forEach((button) => button.addEventListener('click', () => {
      selectCard('bag', button);
      state.bag = { id: button.dataset.builderValue, label: button.dataset.builderLabel, image: button.dataset.builderImage, meta: button.dataset.builderMeta, price: Number(button.dataset.builderPrice) || 80 };
      state.bagVariant = catalogVariant('bag', state.bag.id);
      preview(state.bag, button.closest('[data-builder-bag-panel]')?.dataset.builderBagPanel === 'signature' ? 'AFTER FOUR SIGNATURE BAGS' : 'ESSENTIAL CARRYING BAGS', 'INDEPENDENT RETAIL');
      updateSummary();
    }));
    all('[data-builder-select="mat"]').forEach((button) => button.addEventListener('click', () => {
      selectCard('mat', button);
      state.mat = { id: button.dataset.builderValue, label: button.dataset.builderLabel, image: button.dataset.builderImage, meta: button.dataset.builderMeta };
      refreshMatVariant();
      preview(state.mat, 'AMERICAN MAH JONGG TABLE MAT', state.matSize ? 'SELECTED SIZE' : 'SIZE REQUIRED', 'table-mat');
      if (state.matSize) setText('[data-builder-preview-meta]', `${state.matSize} × ${state.matSize} cm · AF-MAT-${matCodes[state.mat.id]}-${state.matSize}`);
      updateSummary();
    }));
    all('[data-builder-select="mat-size"]').forEach((button) => button.addEventListener('click', () => {
      all('[data-builder-select="mat-size"]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      state.matSize = button.dataset.builderValue;
      refreshMatVariant();
      if (state.mat) { state.mat.meta = `${state.matSize} × ${state.matSize} cm · AF-MAT-${matCodes[state.mat.id]}-${state.matSize}`; preview(state.mat, 'AMERICAN MAH JONGG TABLE MAT', 'SELECTED SIZE', 'table-mat'); }
      updateSummary();
    }));
    all('[data-builder-select="tile"]').forEach((button) => button.addEventListener('click', () => {
      selectCard('tile', button);
      state.tile = { id: button.dataset.builderValue, label: button.dataset.builderLabel, image: button.dataset.builderImage, meta: button.dataset.builderMeta };
      state.tileVariant = catalogVariant('tile', state.tile.id);
      preview(state.tile, 'PANDATIME FIXED EDITION', 'INDEPENDENT RETAIL VALUE'); updateSummary();
    }));
    all('[data-builder-select="rack-product"]').forEach((button) => button.addEventListener('click', () => {
      selectCard('rack-product', button);
      state.rackProduct = { id: button.dataset.builderValue, label: button.dataset.builderLabel, image: button.dataset.builderImage, meta: button.dataset.builderMeta };
      state.rack = null; state.rackVariant = null;
      all('[data-builder-rack-colors]').forEach((panel) => { panel.hidden = panel.dataset.builderRackColors !== state.rackProduct.id; });
      all('[data-builder-select="rack-variant"]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      preview(state.rackProduct, 'STANDARD RACK + PUSHER SET', 'CHOOSE A COLOR'); updateSummary();
    }));
    all('[data-builder-select="rack-variant"]').forEach((button) => button.addEventListener('click', () => {
      all('[data-builder-select="rack-variant"]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      state.rack = { id: button.dataset.builderValue, label: button.dataset.builderLabel, image: button.dataset.builderImage, meta: `${button.dataset.builderValue} · $55 USD` };
      state.rackVariant = catalogVariant('rack', button.dataset.builderProduct, button.dataset.builderValue);
      preview(state.rack, 'STANDARD RACK + PUSHER SET', 'SELECTED COLOR'); updateSummary();
    }));
    all('[data-builder-bag-series]').forEach((button) => button.addEventListener('click', () => {
      const series = button.dataset.builderBagSeries;
      state.bagSeries = series;
      builder.dataset.bagSeries = series;
      all('[data-builder-bag-series]').forEach((item) => item.setAttribute('aria-checked', String(item === button)));
      all('[data-builder-bag-panel]').forEach((panel) => { panel.hidden = panel.dataset.builderBagPanel !== series; });
      requestAnimationFrame(updateAllRails);
    }));
    all('[data-builder-step-go]').forEach((button) => button.addEventListener('click', () => showStep(button.dataset.builderStepGo, true)));
    one('[data-builder-previous]')?.addEventListener('click', () => showStep(state.step - 1, true));
    one('[data-builder-next]')?.addEventListener('click', () => showStep(state.step + 1, true));
    one('[data-builder-mobile-review]')?.addEventListener('click', (event) => {
      if (mobileBuilderQuery.matches) openSheet(5, event.currentTarget);
      else showStep(5, true);
    });
    one('[data-builder-quantity-decrease]')?.addEventListener('click', () => updateQuantity(-1));
    one('[data-builder-quantity-increase]')?.addEventListener('click', () => updateQuantity(1));
    one('[data-builder-quantity]')?.addEventListener('change', (event) => {
      event.currentTarget.value = String(requestedQuantity());
    });
    one('[data-builder-add]')?.addEventListener('click', (event) => addCompleteSet('bag', event.currentTarget));
    one('[data-builder-buy-now]')?.addEventListener('click', () => addCompleteSet('checkout'));
    one('[data-builder-summary-toggle]')?.addEventListener('click', (event) => {
      const open = builder.classList.toggle('is-summary-open');
      event.currentTarget.setAttribute('aria-expanded', String(open));
      const icon = event.currentTarget.querySelector('i'); if (icon) icon.textContent = open ? '−' : '+';
    });
    builder.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-builder-sheet-open]');
      if (!opener || !builder.contains(opener)) return;
      openSheet(Number(opener.dataset.builderSheetOpen), opener);
    });
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-complete-set-sheet-launch]');
      if (!opener || !mobileBuilderQuery.matches) return;
      event.preventDefault();
      openSheet(Number(opener.dataset.completeSetSheetLaunch || 1), opener);
    });
    sheet?.addEventListener('click', (event) => {
      const zoomPrevious = event.target.closest('[data-sheet-preview-zoom-previous]');
      const zoomNext = event.target.closest('[data-sheet-preview-zoom-next]');
      if (zoomPrevious || zoomNext) {
        moveSheetZoom(zoomPrevious ? -1 : 1);
        return;
      }
      const zoomClose = event.target.closest('[data-sheet-preview-zoom-close]');
      const zoomDialog = event.target.closest('[data-sheet-preview-zoom-dialog]');
      const zoomStage = event.target.closest('[data-sheet-preview-zoom-stage]');
      if (zoomClose || event.target === zoomDialog || (zoomStage && !event.target.closest('img, button'))) {
        closeSheetZoom();
        return;
      }
      const zoomButton = event.target.closest('[data-sheet-preview-zoom]');
      if (zoomButton) {
        openSheetZoom(zoomButton);
        return;
      }
      const editButton = event.target.closest('[data-sheet-edit-step]');
      if (editButton && sheetDraft?.step === 5) {
        showSheetStep(Number(editButton.dataset.sheetEditStep));
        return;
      }
      const seriesButton = event.target.closest('[data-sheet-series]');
      if (seriesButton && sheetDraft?.step === 4) {
        const nextSeries = seriesButton.dataset.sheetSeries;
        const currentBag = buttonBy('bag', sheetDraft.bagId);
        sheetDraft.bagSeries = nextSeries;
        if (currentBag?.closest('[data-builder-bag-panel]')?.dataset.builderBagPanel !== nextSeries) sheetDraft.bagId = '';
        renderSheet();
        requestAnimationFrame(() => sheet.querySelector(`[data-sheet-series="${nextSeries}"]`)?.focus());
        return;
      }
      const option = event.target.closest('[data-sheet-select]');
      if (!option || !sheetDraft) return;
      const action = option.dataset.sheetSelect;
      const value = option.dataset.sheetValue;
      if (action === 'bag') sheetDraft.bagId = value;
      if (action === 'mat') { sheetDraft.matId = value; sheetDraft.matSize = ''; }
      if (action === 'mat-size') sheetDraft.matSize = value;
      if (action === 'tile') sheetDraft.tileId = value;
      if (action === 'rack-product') { sheetDraft.rackProductId = value; sheetDraft.rackSku = ''; }
      if (action === 'rack-variant') { sheetDraft.rackProductId = option.dataset.sheetProduct; sheetDraft.rackSku = value; }
      renderSheet();
      requestAnimationFrame(() => sheet.querySelector(`[data-sheet-select="${action}"][data-sheet-value="${CSS.escape(value)}"]`)?.focus());
    });
    sheetBackdrop?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      // Dismiss only the top layer: keep the selection sheet and its draft open.
      if (closeSheetZoom()) return;
      closeSheet();
    });
    one('[data-builder-sheet-close]')?.addEventListener('click', () => closeSheet());
    sheetPrevious?.addEventListener('click', () => {
      if (!sheetDraft || sheetDraft.step <= 1 || state.adding) return;
      showSheetStep(sheetDraft.step - 1);
    });
    sheetConfirm?.addEventListener('click', () => {
      if (sheetDraft?.step === 2 && sheetDraft.matId && !sheetDraft.matSize) {
        sheet.querySelector('[data-sheet-size-section]')?.scrollIntoView({ behavior: reducedMotionQuery.matches ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      commitSheetDraft();
    });
    sheetAdd?.addEventListener('click', (event) => addCompleteSet('bag', event.currentTarget));
    sheetCheckout?.addEventListener('click', () => addCompleteSet('checkout'));
    sheetScroll?.addEventListener('scroll', updateSheetPreviewMode, { passive: true });
    document.addEventListener('keydown', (event) => {
      if (!sheet || sheet.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (closeSheetZoom()) return;
        closeSheet();
        return;
      }
      const zoom = sheet.querySelector('[data-sheet-preview-zoom-dialog]:not([hidden])');
      if (zoom && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        event.preventDefault();
        moveSheetZoom(event.key === 'ArrowLeft' ? -1 : 1);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(sheet.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((node) => !node.hidden && node.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !sheet.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    });
    const sheetHandle = one('[data-builder-sheet-handle]');
    sheetHandle?.addEventListener('pointerdown', (event) => {
      sheetSwipe = { pointerId: event.pointerId, startY: event.clientY };
      sheetHandle.setPointerCapture?.(event.pointerId);
    });
    sheetHandle?.addEventListener('pointermove', (event) => {
      if (!sheetSwipe || event.pointerId !== sheetSwipe.pointerId || !sheet) return;
      sheet.style.transform = `translate3d(0, ${Math.max(0, event.clientY - sheetSwipe.startY)}px, 0)`;
    });
    const finishSheetSwipe = (event) => {
      if (!sheetSwipe || event.pointerId !== sheetSwipe.pointerId || !sheet) return;
      const distance = Math.max(0, event.clientY - sheetSwipe.startY);
      sheetSwipe = null;
      if (distance > 80) closeSheet();
      else sheet.style.removeProperty('transform');
    };
    sheetHandle?.addEventListener('pointerup', finishSheetSwipe);
    sheetHandle?.addEventListener('pointercancel', finishSheetSwipe);
    mobileBuilderQuery.addEventListener?.('change', (event) => { if (!event.matches) closeSheet({ restoreFocus: false, immediate: true }); });
    all('[data-builder-rail]').forEach((rail) => {
      rail.addEventListener('scroll', () => updateRail(rail), { passive: true });
      const controls = rail.nextElementSibling;
      controls?.querySelector('[data-builder-rail-previous]')?.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * 0.82, behavior: 'smooth' }));
      controls?.querySelector('[data-builder-rail-next]')?.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * 0.82, behavior: 'smooth' }));

      rail.addEventListener('wheel', (event) => {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        if (max <= 2) return;
        const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
        const target = Math.min(max, Math.max(0, rail.scrollLeft + delta));
        if (!delta || Math.abs(target - rail.scrollLeft) < 1) return;
        event.preventDefault();
        rail.scrollLeft = target;
      }, { passive: false });

      let mouseDrag = null;
      let suppressCardClick = false;
      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        mouseDrag = { pointerId: event.pointerId, startX: event.clientX, startScroll: rail.scrollLeft };
        suppressCardClick = false;
      });
      rail.addEventListener('pointermove', (event) => {
        if (!mouseDrag || event.pointerId !== mouseDrag.pointerId) return;
        const distance = event.clientX - mouseDrag.startX;
        if (Math.abs(distance) <= 10) return;
        if (!suppressCardClick) rail.setPointerCapture?.(event.pointerId);
        suppressCardClick = true;
        rail.classList.add('is-dragging');
        event.preventDefault();
        rail.scrollLeft = mouseDrag.startScroll - distance;
      });
      const finishMouseDrag = (event) => {
        if (!mouseDrag || event.pointerId !== mouseDrag.pointerId) return;
        mouseDrag = null;
        rail.classList.remove('is-dragging');
        setTimeout(() => { suppressCardClick = false; }, 0);
      };
      rail.addEventListener('pointerup', finishMouseDrag);
      rail.addEventListener('pointercancel', finishMouseDrag);
      rail.addEventListener('click', (event) => {
        if (!suppressCardClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);

      const progress = controls?.querySelector('.complete-set-rail-progress');
      const thumb = progress?.querySelector('span');
      let progressDrag = null;
      const updateFromPointer = (clientX) => {
        if (!progress || !thumb) return;
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const track = progress.getBoundingClientRect();
        const thumbBox = thumb.getBoundingClientRect();
        const travel = Math.max(1, track.width - thumbBox.width);
        const offset = progressDrag?.offset ?? thumbBox.width / 2;
        const position = Math.min(travel, Math.max(0, clientX - track.left - offset));
        rail.scrollLeft = max * (position / travel);
      };
      progress?.addEventListener('pointerdown', (event) => {
        if (event.button !== undefined && event.button !== 0) return;
        const thumbBox = thumb.getBoundingClientRect();
        progressDrag = { pointerId: event.pointerId, offset: event.target === thumb ? event.clientX - thumbBox.left : thumbBox.width / 2 };
        progress.setPointerCapture?.(event.pointerId);
        controls.classList.add('is-progress-dragging');
        updateFromPointer(event.clientX);
        event.preventDefault();
      });
      progress?.addEventListener('pointermove', (event) => {
        if (!progressDrag || event.pointerId !== progressDrag.pointerId) return;
        updateFromPointer(event.clientX);
        event.preventDefault();
      });
      const finishProgressDrag = (event) => {
        if (!progressDrag || event.pointerId !== progressDrag.pointerId) return;
        progressDrag = null;
        controls?.classList.remove('is-progress-dragging');
      };
      progress?.addEventListener('pointerup', finishProgressDrag);
      progress?.addEventListener('pointercancel', finishProgressDrag);
    });
    window.addEventListener('resize', updateAllRails, { passive: true });
    decorateCatalogAvailability();
    const initialBagButton = one('[data-builder-select="bag"][aria-pressed="true"]');
    state.bagVariant = catalogVariant('bag', state.bag.id);
    if (!state.bagVariant?.available) {
      const firstAvailableBag = all('[data-builder-select="bag"]').find((button) => !button.disabled);
      if (firstAvailableBag && firstAvailableBag !== initialBagButton) firstAvailableBag.click();
    }
    showStep(1, false); updateSummary(); updateAllRails();
  });
});
